import React, { useContext, useState } from 'react'
import { ThemeContext } from 'styled-components'
import { Currency } from '@pancakeswap/sdk'
import { Button, InfoIcon, Text } from '@pancakeswap/uikit'
import { AutoColumn } from 'components/Layout/Column'
import { AutoRow, RowBetween } from 'components/Layout/Row'
import { SwapCallbackError } from 'components/styleds'
import { TokenAmount } from 'sdk/entities/tokenAmount'
import CircleLoader from 'components/Loader/CircleLoader'
import { WarningLabelRow } from '../../../components/AddressInputPanel'
import { ChainId } from '../../../config/constants/chainId'
import { CheckItem } from '../../../components/ActiveBridgeInfo/ActiveBridgeInfo'
import { GreyCard } from '../../../components/Card'

export default function BridgeModalFooter({
  currency,
  fees,
  onConfirm,
  swapErrorMessage,
  disabledConfirm,
  targetChainId,
  isWithdrawalToOtherNetwork,
}: {
  currency: Currency
  fees: TokenAmount | undefined
  onConfirm: () => void
  swapErrorMessage: string | undefined
  disabledConfirm?: boolean
  isWithdrawalToOtherNetwork: boolean
  targetChainId?: number
}) {
  const theme = useContext(ThemeContext)
  // useBridgingFees(sourceChainId)
  const [isAccepted, setIsAccepted] = useState(false)

  // show during bridgings to Ethereum
  const isBridgingToEth =
    targetChainId === ChainId.ETHEREUM && (isWithdrawalToOtherNetwork === undefined || !isWithdrawalToOtherNetwork)

  // show only during withdrawals to another network && to Ethereum
  const isWithdrawalToAnotherNetworkAndToEth = isWithdrawalToOtherNetwork && targetChainId === ChainId.ETHEREUM

  const handleAccept = () => setIsAccepted(!isAccepted)

  return (
    <div style={{ paddingBottom: isWithdrawalToAnotherNetworkAndToEth || isBridgingToEth ? '30px' : '0' }}>
      {isWithdrawalToOtherNetwork ? (
        <></>
      ) : (
        <AutoColumn>
          <RowBetween align="center">
            <Text fontWeight={400} fontSize="14" color={theme.colors.text}>
              Protocol incentive fees
            </Text>
            <Text
              fontWeight={500}
              fontSize="14"
              color={theme.colors.text}
              style={{
                justifyContent: 'center',
                alignItems: 'center',
                display: 'flex',
                textAlign: 'right',
                paddingLeft: '10px',
              }}
            >
              {fees === undefined ? <CircleLoader /> : `${fees.toFixed(fees.token.decimals ?? 6)} ${currency.symbol}`}
            </Text>
          </RowBetween>
        </AutoColumn>
      )}

      {(isBridgingToEth || isWithdrawalToAnotherNetworkAndToEth) && (
        <AutoRow margin="0 auto" maxWidth={320}>
          <RowBetween align="center">
            <WarningLabelRow>
              <InfoIcon mr="10px" color="#FF0000" />
              <Text fontSize="14px">
                ⚠️ Stop! ⚠️
                <br /> {isWithdrawalToOtherNetwork ? 'Withdrawal to another network' : 'Bridging'} consists of 2
                transactions:
                <br />
                a) <strong>deposit</strong> which you are making now
                <br />
                b) <strong>claiming</strong> which you are planning to complete on Ethereum.{' '}
              </Text>
            </WarningLabelRow>
          </RowBetween>
        </AutoRow>
      )}

      {(isBridgingToEth || isWithdrawalToAnotherNetworkAndToEth) && (
        <AutoRow margin="0 auto" maxWidth={320}>
          <RowBetween align="center">
            <WarningLabelRow>
              <InfoIcon mr="10px" color="#FF0000" />
              <Text fontSize="14px">
                Make sure you have enough ETH balance (+0.1 ETH) in your account to complete the claiming. Otherwise you
                will <strong>not be able</strong> to receive your funds on Ethereum. Please continue with caution.{' '}
              </Text>
            </WarningLabelRow>
          </RowBetween>
        </AutoRow>
      )}

      <AutoRow margin="20px auto 12px" maxWidth={320}>
        <RowBetween align="center">
          <Text fontWeight={400} fontSize="14" color={theme.colors.text}>
            After you confirm, you will need to wait for enough confirmations, switch the network and then actively
            claim your tokens.{' '}
            <strong>
              Please be aware that for the claiming out of the pool you need to pay gas fees in the target network!
            </strong>
          </Text>
        </RowBetween>
      </AutoRow>

      {(isBridgingToEth || isWithdrawalToAnotherNetworkAndToEth) && (
        <AutoRow maxWidth={320} margin="10px auto">
          <GreyCard
            display="flex"
            onClick={handleAccept}
            style={{ backgroundColor: isAccepted && '#0050ff', cursor: 'pointer' }}
          >
            <CheckItem iconMarginBottom="0" checkboxWidth="20px" checked={isAccepted} />
            <Text
              ml="10px"
              textAlign="center"
              fontSize="13px"
              color={isAccepted ? theme.colors.backgroundAlt : theme.colors.text}
            >
              I understand that I have to pay with ETH for claiming.
            </Text>
          </GreyCard>
        </AutoRow>
      )}

      <AutoRow>
        <Button
          variant="primary"
          width="100%"
          onClick={onConfirm}
          disabled={disabledConfirm || ((isBridgingToEth || isWithdrawalToAnotherNetworkAndToEth) && !isAccepted)}
          style={{ margin: '10px 0 0 0' }}
          id="confirm-swap-or-send"
        >
          {isWithdrawalToOtherNetwork ? 'Confirm Withdrawal' : 'Confirm Bridging'}
        </Button>

        {swapErrorMessage ? <SwapCallbackError error={swapErrorMessage} /> : null}
      </AutoRow>
    </div>
  )
}
